"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutTransform = exports.rotateBoxPositions = exports.rotateBox90Degrees = exports.getBoxPositionCOM = exports.getBoxPositionsBoundingBoxCenter = exports.getBoxPositionsBounds = exports.getEffectiveDimensions = void 0;
function getEffectiveDimensions(bpo, boxes) {
    const box = boxes[bpo.index];
    let { width, length } = box.dimensions;
    const mp = bpo.multipick || 0;
    if (bpo.multipickAlongWidth) {
        width *= mp + 1;
    }
    else {
        length *= mp + 1;
    }
    if (bpo.rotated) {
        const tmp = width;
        width = length;
        length = tmp;
    }
    return { width, length };
}
exports.getEffectiveDimensions = getEffectiveDimensions;
function _getCenterBPO(boxes, bpo, scale_factor, pallet_dims) {
    let { width, length } = getEffectiveDimensions(bpo, boxes);
    width *= scale_factor / pallet_dims.width;
    length *= scale_factor / pallet_dims.length;
    let p = {
        x: bpo.position.x + width / 2,
        y: bpo.position.y + length / 2,
    };
    return p;
}
function getBoxPositionsBounds(boxes, bpos, scale_factor, pallet_dims) {
    if (bpos.length === 0)
        return { xLow: 0, yLow: 0, yHigh: 0, xHigh: 0 };
    let x_low = 1, x_high = 0, y_low = 1, y_high = 0;
    bpos.forEach((bpo) => {
        const { x: bx, y: by } = _getCenterBPO(boxes, bpo, scale_factor, pallet_dims);
        let { width, length } = getEffectiveDimensions(bpo, boxes);
        width *= scale_factor / pallet_dims.width;
        length *= scale_factor / pallet_dims.length;
        const bXlow = bx - width / 2;
        if (bXlow < x_low)
            x_low = bXlow;
        const bXhigh = bx + width / 2;
        if (bXhigh > x_high)
            x_high = bXhigh;
        const bYlow = by - length / 2;
        if (bYlow < y_low)
            y_low = bYlow;
        const bYhigh = by + length / 2;
        if (bYhigh > y_high)
            y_high = bYhigh;
    });
    return {
        xLow: x_low,
        xHigh: x_high,
        yLow: y_low,
        yHigh: y_high,
    };
}
exports.getBoxPositionsBounds = getBoxPositionsBounds;
function getBoxPositionsBoundingBoxCenter(boxes, bpos, scale_factor, pallet_dims) {
    const lBounds = getBoxPositionsBounds(boxes, bpos, scale_factor, pallet_dims);
    let x = (lBounds.xHigh - lBounds.xLow) / 2 + lBounds.xLow, y = (lBounds.yHigh - lBounds.yLow) / 2 + lBounds.yLow;
    return { x, y };
}
exports.getBoxPositionsBoundingBoxCenter = getBoxPositionsBoundingBoxCenter;
function getBoxPositionCOM(boxes, bpos, scale_factor, pallet_dims) {
    // Determine COM using com = (m1*y1 + m2*y2 + ...) / (m1 + m2 + ...)
    // Where mi is the weight (size of box, e.g. double_length = 2 * y => m = 2)
    // and yi is the center y coord of the box
    let x = 0, y = 0, xWeights = bpos.length, // = 1 for each to start (all even).
    yWeights = bpos.length;
    if (bpos.length === 0)
        return { x, y };
    bpos.forEach((bpo) => {
        let { x: bx, y: by } = _getCenterBPO(boxes, bpo, scale_factor, pallet_dims);
        //Weight factor in COM equation numerator
        const mp = bpo.multipick || 0;
        if ((!bpo.multipickAlongWidth && !bpo.rotated) ||
            (bpo.multipickAlongWidth && bpo.rotated)) {
            by *= mp + 1;
            yWeights += mp;
        }
        else {
            bx *= mp + 1;
            xWeights += mp;
        }
        x += bx;
        y += by;
    });
    // unrotated x the same
    x /= xWeights;
    y /= yWeights;
    return { x, y };
}
exports.getBoxPositionCOM = getBoxPositionCOM;
/**
 * Rotates a box 90 degrees from current rotation
 * @param boxPosition The position data of the box
 * @returns the box position of the box after rotating it 90 degrees
 */
function rotateBox90Degrees(boxPosition) {
    if (!boxPosition.spin) {
        if (boxPosition.rotated) {
            // box is at 270 deg
            // rotate box to 0 deg
            return { ...boxPosition, rotated: false, spin: true };
        }
        // box is at 180 deg
        // rotate box to 270 deg
        return { ...boxPosition, rotated: true, spin: false };
    }
    if (boxPosition.rotated) {
        // box is at 90 deg
        // rotate box to 180 deg
        return { ...boxPosition, rotated: false, spin: false };
    }
    // box is at 0 deg
    // rotate box to 90 deg
    return { ...boxPosition, rotated: true, spin: true };
}
exports.rotateBox90Degrees = rotateBox90Degrees;
function getLabelDirection(rotated, labelDirection) {
    // labelDirection 1 is left, 2 is front, 3 is right, 4 is back
    // rotated is true then we're either at 90 or 270 degrees
    if (rotated) {
        if (labelDirection === 1 || labelDirection === 3) {
            // label is left/right and we're rotated so they're now up/down
            return 'y';
        }
        return 'x'; // label is up/down and we're rotated so they're now left/right
    }
    else {
        if (labelDirection === 1 || labelDirection === 3) {
            // label is left/right and we're not rotated so they're still left/right
            return 'x';
        }
        return 'y'; // label is up/down and we're not rotated so they're still up/down
    }
}
// convert to norm space x -> x * pallet.width / norm, y -> y * pallet.length / norm;
function _rotateBoxPosition_t(boxes, bpo, about, scale_factor, pallet_dims) {
    const s = Math.sin(Math.PI / 2);
    const c = Math.cos(Math.PI / 2);
    let { x, y } = _getCenterBPO(boxes, bpo, scale_factor, pallet_dims);
    // translate to origin.
    x -= about.x;
    y -= about.y;
    // copy
    let ptx = x, pty = y;
    // rotate
    let lratio = pallet_dims.length / pallet_dims.width;
    let wratio = 1 / lratio;
    x = ptx * c - pty * lratio * s;
    y = ptx * wratio * s + pty * c;
    // translate
    x += about.x;
    y += about.y;
    bpo.rotated = !bpo.rotated;
    let { width, length } = boxes[bpo.index].dimensions;
    const mp = bpo.multipick || 0;
    if (bpo.multipickAlongWidth) {
        width *= mp + 1;
    }
    else {
        length *= mp + 1;
    }
    if (bpo.rotated) {
        let tmp = width;
        width = length;
        length = tmp;
    }
    width *= scale_factor / pallet_dims.width;
    length *= scale_factor / pallet_dims.length;
    x -= width / 2;
    y -= length / 2;
    bpo.position = { x, y };
}
function rotateBoxPositions(boxes, bpos, scale_factor, pallet_dims) {
    const com = getBoxPositionCOM(boxes, bpos, scale_factor, pallet_dims);
    bpos.forEach(function (bpo) {
        _rotateBoxPosition_t(boxes, bpo, com, scale_factor, pallet_dims);
    });
}
exports.rotateBoxPositions = rotateBoxPositions;
// Layout Transformations For Use In AutoStack.
// 1. Rotate 180deg
// 2. Reflect Y
// 3. Reflect X
var LayoutTransform;
(function (LayoutTransform) {
    // utils.
    function cloneLayout(pLayout) {
        const lNewLayout = { ...pLayout, boxPositions: [...pLayout.boxPositions] };
        lNewLayout.boxPositions = lNewLayout.boxPositions.map(function (lBoxPosition) {
            const lNewPosition = { ...lBoxPosition };
            lNewPosition.position = { ...lBoxPosition.position };
            return lNewPosition;
        });
        return lNewLayout;
    }
    let TransformType;
    (function (TransformType) {
        TransformType[TransformType["Identity"] = 0] = "Identity";
        TransformType[TransformType["Spin"] = 1] = "Spin";
        TransformType[TransformType["ReflectX"] = 2] = "ReflectX";
        TransformType[TransformType["ReflectY"] = 3] = "ReflectY";
        TransformType[TransformType["ReflectGlobalX"] = 4] = "ReflectGlobalX";
        TransformType[TransformType["ReflectGlobalY"] = 5] = "ReflectGlobalY";
    })(TransformType = LayoutTransform.TransformType || (LayoutTransform.TransformType = {}));
    LayoutTransform.TransformTypeNames = [
        'None',
        'Rotate 180',
        'Mirror Vertical',
        'Mirror Horizontal',
    ];
    function Transform(pType, pPallet, pBoxes, pLayoutIndex) {
        let lTransformer = Identity;
        switch (pType) {
            case TransformType.Identity:
                lTransformer = Identity;
                break;
            case TransformType.Spin:
                lTransformer = Spin;
                break;
            case TransformType.ReflectX:
                lTransformer = ReflectX;
                break;
            case TransformType.ReflectY:
                lTransformer = ReflectY;
                break;
            case TransformType.ReflectGlobalX:
                lTransformer = ReflectGlobalX;
                break;
            case TransformType.ReflectGlobalY:
                lTransformer = ReflectGlobalY;
                break;
        }
        return lTransformer(pPallet, pBoxes, pLayoutIndex);
    }
    LayoutTransform.Transform = Transform;
    function Identity(pPallet, pBoxes, pLayoutIndex) {
        const lNewLayout = cloneLayout(pPallet.Layouts[pLayoutIndex]);
        return lNewLayout;
    }
    LayoutTransform.Identity = Identity;
    // Spin: rotate 180deg
    function Spin(pPallet, pBoxes, pLayoutIndex) {
        const lNewLayout = cloneLayout(pPallet.Layouts[pLayoutIndex]);
        for (let i = 0; i < Math.floor(180 / 90); // ie. 2 x 90 deg rotation.
         i++) {
            rotateBoxPositions(pBoxes, lNewLayout.boxPositions, 1, pPallet.Dimensions);
        }
        // rotate boxes if they have a label
        const box = pBoxes.find(b => b.id === lNewLayout.box_id);
        if (!!box && box.labelSide > 0) {
            lNewLayout.boxPositions.forEach(function (pBoxPosition) {
                pBoxPosition.spin = !pBoxPosition.spin;
            });
        }
        return lNewLayout;
    }
    LayoutTransform.Spin = Spin;
    function ReflectXHelper(pPallet, pBoxes, pLayoutIndex, pReflectAboutBoundingBoxCenter) {
        const lNewLayout = cloneLayout(pPallet.Layouts[pLayoutIndex]);
        let lLayoutCenter;
        if (pReflectAboutBoundingBoxCenter) {
            lLayoutCenter = getBoxPositionsBoundingBoxCenter(pBoxes, lNewLayout.boxPositions, 1, pPallet.Dimensions);
        }
        lNewLayout.boxPositions.forEach(function (pBoxPosition) {
            let lBox = pBoxes[pBoxPosition.index];
            let bl = lBox.dimensions.length;
            let bw = lBox.dimensions.width;
            const mp = pBoxPosition.multipick || 0;
            if (pBoxPosition.multipickAlongWidth) {
                bw *= mp + 1;
            }
            else {
                bl *= mp + 1;
            }
            let lBoxLength = (pBoxPosition.rotated ? bw : bl) / pPallet.Dimensions.length;
            let lNewY;
            if (pReflectAboutBoundingBoxCenter) {
                lNewY = lLayoutCenter.y * 2 - pBoxPosition.position.y - lBoxLength;
            }
            else {
                lNewY = 1 - pBoxPosition.position.y - lBoxLength;
            }
            pBoxPosition.position.y = lNewY;
        });
        return lNewLayout;
    }
    LayoutTransform.ReflectXHelper = ReflectXHelper;
    function ReflectX(pPallet, pBoxes, pLayoutIndex) {
        const layout = ReflectXHelper(pPallet, pBoxes, pLayoutIndex, true);
        const box = pBoxes.find(b => b.id === layout.box_id);
        if (!!box && box.labelSide > 0) {
            layout.boxPositions.forEach(function (boxPosition) {
                const labelDirection = getLabelDirection(boxPosition.rotated, box.labelSide);
                if (labelDirection === 'y') {
                    boxPosition.spin = !boxPosition.spin;
                }
            });
        }
        return layout;
    }
    LayoutTransform.ReflectX = ReflectX;
    function ReflectGlobalX(pPallet, pBoxes, pLayoutIndex) {
        return ReflectXHelper(pPallet, pBoxes, pLayoutIndex, false);
    }
    LayoutTransform.ReflectGlobalX = ReflectGlobalX;
    function ReflectYHelper(pPallet, pBoxes, pLayoutIndex, pReflectAboutBoundingBoxCenter) {
        const lNewLayout = cloneLayout(pPallet.Layouts[pLayoutIndex]);
        let lLayoutCenter;
        if (pReflectAboutBoundingBoxCenter) {
            lLayoutCenter = getBoxPositionsBoundingBoxCenter(pBoxes, lNewLayout.boxPositions, 1, pPallet.Dimensions);
        }
        lNewLayout.boxPositions.forEach(function (pBoxPosition) {
            let lBox = pBoxes[pBoxPosition.index];
            let bl = lBox.dimensions.length;
            let bw = lBox.dimensions.width;
            const mp = pBoxPosition.multipick || 0;
            if (pBoxPosition.multipickAlongWidth) {
                bw *= mp + 1;
            }
            else {
                bl *= mp + 1;
            }
            let lBoxWidth = (pBoxPosition.rotated ? bl : bw) / pPallet.Dimensions.width;
            let lNewX;
            if (pReflectAboutBoundingBoxCenter) {
                lNewX = 2 * lLayoutCenter.x - pBoxPosition.position.x - lBoxWidth;
            }
            else {
                lNewX = 1 - pBoxPosition.position.x - lBoxWidth;
            }
            pBoxPosition.position.x = lNewX;
        });
        return lNewLayout;
    }
    function ReflectY(pPallet, pBoxes, pLayoutIndex) {
        const layout = ReflectYHelper(pPallet, pBoxes, pLayoutIndex, true);
        const box = pBoxes.find(b => b.id === layout.box_id);
        if (!!box && box.labelSide > 0) {
            layout.boxPositions.forEach(function (boxPosition) {
                const labelDirection = getLabelDirection(boxPosition.rotated, box.labelSide);
                if (labelDirection === 'x') {
                    boxPosition.spin = !boxPosition.spin;
                }
            });
        }
        return layout;
    }
    LayoutTransform.ReflectY = ReflectY;
    function ReflectGlobalY(pPallet, pBoxes, pLayoutIndex) {
        return ReflectYHelper(pPallet, pBoxes, pLayoutIndex, false);
    }
    LayoutTransform.ReflectGlobalY = ReflectGlobalY;
})(LayoutTransform = exports.LayoutTransform || (exports.LayoutTransform = {}));
